'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function ContactFormSection() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    vehicle: '',
    message: '',
  });

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    if (isHydrated) {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isHydrated) {
      console.log('Form submitted:', formData);
      alert('¡Gracias por tu solicitud! Te contactaremos pronto.');
    }
  };

  const services = [
    { id: 'service_ppf', value: 'ppf', label: 'Laminado PPF' },
    { id: 'service_ceramic', value: 'ceramic', label: 'Ceramic Coating' },
    { id: 'service_tinting', value: 'tinting', label: 'Window Tinting' },
    { id: 'service_detailing', value: 'detailing', label: 'Auto Detailing' },
    { id: 'service_combo', value: 'combo', label: 'Paquete Combo' },
    { id: 'service_other', value: 'other', label: 'Otro / Consulta' },
  ];

  return (
    <section className="py-20 px-6 lg:px-12 bg-black">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left: Form */}
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-white mb-6 tracking-tight">
              SOLICITA TU <span className="text-gradient-red">CONSULTA GRATUITA</span>
            </h2>
            <p className="text-white/60 text-lg leading-relaxed mb-8">
              Completa el formulario y te contactaremos para evaluar tu vehículo y ofrecerte la mejor solución.
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Name */}
              <div>
                <label htmlFor="name" className="block text-white/80 text-sm font-heading tracking-wider mb-2">
                  NOMBRE COMPLETO *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-primary transition-colors"
                  placeholder="Juan Pérez"
                />
              </div>

              {/* Email & Phone */}
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="email" className="block text-white/80 text-sm font-heading tracking-wider mb-2">
                    EMAIL *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-primary transition-colors"
                    placeholder="juan@email.com"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-white/80 text-sm font-heading tracking-wider mb-2">
                    TELÉFONO *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-primary transition-colors"
                    placeholder="(809) 555-1234"
                  />
                </div>
              </div>

              {/* Service */}
              <div>
                <label htmlFor="service" className="block text-white/80 text-sm font-heading tracking-wider mb-2">
                  SERVICIO DE INTERÉS *
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                  className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-primary transition-colors"
                >
                  <option value="">Selecciona un servicio</option>
                  {services.map((service) => (
                    <option key={service.id} value={service.value} className="bg-card text-white">
                      {service.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Vehicle */}
              <div>
                <label htmlFor="vehicle" className="block text-white/80 text-sm font-heading tracking-wider mb-2">
                  VEHÍCULO (Marca, Modelo, Año)
                </label>
                <input
                  type="text"
                  id="vehicle"
                  name="vehicle"
                  value={formData.vehicle}
                  onChange={handleChange}
                  className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-primary transition-colors"
                  placeholder="Ej: Mercedes-Benz C300 2024"
                />
              </div>

              {/* Message */}
              <div>
                <label htmlFor="message" className="block text-white/80 text-sm font-heading tracking-wider mb-2">
                  MENSAJE ADICIONAL
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-primary transition-colors resize-none"
                  placeholder="Cuéntanos más sobre lo que necesitas..."
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-primary hover:bg-primary/90 text-white px-8 py-5 rounded-full font-heading text-sm tracking-wider transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 animate-pulse-glow"
              >
                ENVIAR SOLICITUD
                <Icon name="PaperAirplaneIcon" size={20} variant="solid" />
              </button>

              <p className="text-white/40 text-xs text-center">
                Al enviar este formulario, aceptas nuestra política de privacidad
              </p>
            </form>
          </div>

          {/* Right: Info Cards */}
          <div className="space-y-6">
            {/* Response Time */}
            <div className="glass-card p-8 rounded-[32px]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <Icon name="ClockIcon" size={24} variant="outline" className="text-primary" />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-white mb-2 tracking-wider">
                    RESPUESTA RÁPIDA
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Te contactamos en menos de 24 horas para agendar tu consulta gratuita.
                  </p>
                </div>
              </div>
            </div>

            {/* Free Consultation */}
            <div className="glass-card p-8 rounded-[32px]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <Icon name="CurrencyDollarIcon" size={24} variant="outline" className="text-primary" />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-white mb-2 tracking-wider">
                    CONSULTA GRATIS
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Evaluamos tu vehículo sin compromiso y te ofrecemos la mejor solución personalizada.
                  </p>
                </div>
              </div>
            </div>

            {/* Warranty */}
            <div className="glass-card p-8 rounded-[32px]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <Icon name="ShieldCheckIcon" size={24} variant="solid" className="text-primary" />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-white mb-2 tracking-wider">
                    GARANTÍA INCLUIDA
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Todos nuestros servicios incluyen garantía del fabricante y satisfacción 100% garantizada.
                  </p>
                </div>
              </div>
            </div>

            {/* Certified */}
            <div className="glass-card p-8 rounded-[32px]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <Icon name="CheckBadgeIcon" size={24} variant="solid" className="text-primary" />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-white mb-2 tracking-wider">
                    CERTIFICADOS
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Instaladores certificados por XPEL, 3M y SunTek. Tecnología de nivel competición.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}